import React from 'react'
import { PUBLIC_URL } from '../../config/settings/environment'
import {
  ChevronIconDown,
  Column,
  Link,
  Logo,
  LogoLink,
  PersonIcon,
  Root,
  Row,
  User,
  UserName
} from './HeaderSection.styles'
import { Popover, PopoverMenuItem } from '@chilecompra/react-kit/components'
import { ArrowBack } from '@mui/icons-material'
import { useSelector } from 'react-redux'

/**
 * The HeaderSection's container.
 */
const HeaderSection = () => {
  // FUNCIONES PARA POPOVER
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => {
    document.body.classList.add('popover-open')
    setOpen(true)
  }
  const handleClose = () => {
    document.body.classList.remove('popover-open')
    setOpen(false)
  }
  const handleLogout = () => {
    handleClose()
    const redirectUrl = process.env.REACT_APP_MERCADOPUBLICO_URL
    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      console.error('No se encontró la variable de entorno REACT_APP_MERCADOPUBLICO_URL')
    }
  }

  const backToCM = () => {
    const redirectUrl = process.env.REACT_APP_CONVENIOSMARCO_URL
    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      console.error('No se encontró la variable de entorno REACT_APP_CONVENIOSMARCO_URL')
    }
  }

  const { name } = useSelector(state => state.headerSection)
  // const name = 'Cecile Francoise González Mendez'

  return (
    <Root>
      <Row alignItems="center" padding="10px">
        <Column sm={6} xs={12}>
          <Row alignItems="center">
            <LogoLink to="#">
              <Logo alt="Mercado Público" src={`${PUBLIC_URL}/assets/images/logo_direccion-chilecompra.svg`} />
            </LogoLink>
            <Link onClick={backToCM}>Volver al listado de Convenios Marco</Link>
          </Row>
        </Column>
        {name && (
          <Column sm={6} xs={12}>
            <User>
              <PersonIcon />
              <Popover
                anchor={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <UserName>{name}</UserName>
                    <ChevronIconDown isOpen={open} />
                  </div>
                }
                onClose={handleClose}
                onOpen={handleOpen}
                originX="right"
                originY="bottom"
              >
                <PopoverMenuItem enableClose onClick={handleLogout}>
                  <ArrowBack sx={{ fontSize: 18, marginRight: 1 }} />
                  Volver a ChileCompra
                </PopoverMenuItem>
              </Popover>
            </User>
          </Column>
        )}
      </Row>
    </Root>
  )
}

export default HeaderSection
